import { useEffect, useRef, useState } from "react";
import api from "../../lib/api";
import { Send, MessageSquare, User } from "lucide-react";

export default function ChatInbox() {
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);

  const loadThreads = () => api.get("/chat/threads").then((r) => setThreads(r.data)).catch(() => {});
  const loadMsgs = (cid) => api.get(`/chat/threads/${cid}`).then((r) => setMsgs(r.data)).catch(() => {});

  useEffect(() => { loadThreads(); const t = setInterval(loadThreads, 5000); return () => clearInterval(t); }, []);
  useEffect(() => {
    if (!active) return;
    loadMsgs(active);
    const t = setInterval(() => loadMsgs(active), 3500);
    return () => clearInterval(t);
  }, [active]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!text.trim() || !active) return;
    const t = text.trim(); setText("");
    await api.post(`/chat/threads/${active}/reply`, { text: t });
    loadMsgs(active); loadThreads();
  };

  const activeThread = threads.find((t) => t.customerId === active);

  return (
    <div>
      <h1 className="font-serif text-3xl sm:text-4xl text-white mb-1">Canlı Sohbet</h1>
      <p className="text-zinc-400 text-sm mb-6">Müşterilerle anlık yazışın</p>

      <div className="grid md:grid-cols-3 gap-4 h-[calc(100vh-260px)] min-h-[420px]">
        <div className="card-lux overflow-y-auto no-scrollbar" data-testid="chat-threads">
          {threads.length === 0 && <p className="text-zinc-600 text-sm text-center py-10">Henüz mesaj yok</p>}
          {threads.map((t) => (
            <button key={t.customerId} onClick={() => setActive(t.customerId)} className={`w-full text-left px-4 py-3 border-b border-[#D4AF37]/10 hover:bg-white/5 transition-colors ${active === t.customerId ? "bg-[#D4AF37]/10" : ""}`} data-testid={`thread-${t.customerId}`}>
              <div className="flex items-center gap-2"><User size={15} className="text-[#D4AF37]" /><span className="text-white text-sm font-medium">{t.customerName}</span></div>
              <p className="text-xs text-zinc-500 mt-1 truncate">{t.lastText}</p>
            </button>
          ))}
        </div>

        <div className="card-lux md:col-span-2 flex flex-col">
          {!active ? (
            <div className="flex-1 flex flex-col items-center justify-center text-zinc-600 gap-3"><MessageSquare size={40} /><p className="text-sm">Bir sohbet seçin</p></div>
          ) : (
            <>
              <div className="px-5 py-3 border-b border-[#D4AF37]/20 font-serif text-lg text-white">{activeThread?.customerName}</div>
              <div className="flex-1 overflow-y-auto p-4 space-y-3 no-scrollbar" data-testid="chat-messages">
                {msgs.map((m) => (
                  <div key={m.id} className={`flex ${m.fromRole === "owner" ? "justify-end" : "justify-start"}`}>
                    <div className={`max-w-[75%] px-4 py-2.5 rounded-2xl text-sm ${m.fromRole === "owner" ? "btn-gold rounded-br-sm" : "bg-[#1E1E24] text-zinc-200 border border-[#D4AF37]/20"}`}>{m.text}</div>
                  </div>
                ))}
                <div ref={endRef} />
              </div>
              <div className="p-3 border-t border-[#D4AF37]/20 flex gap-2">
                <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Yanıt yazın..." className="lux-input flex-1" data-testid="inbox-input" />
                <button onClick={send} className="btn-gold h-11 w-11 rounded-xl flex items-center justify-center" data-testid="inbox-send"><Send size={18} /></button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
